import React, { useState, useCallback } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { MenuSidebar } from '../components/MenuSidebar';

const { Content } = Layout;

export const MainLayout: React.FC= () => {
    const [collapsed, setCollapsed] = useState(true);
    const [refreshKey, setRefreshKey] = useState(0);

    const toggleSidebar = useCallback(() => {
        setCollapsed((prevCollapsed) => !prevCollapsed);
    }, []);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Layout>
                <MenuSidebar sidebar={collapsed} toggleSidebar={toggleSidebar} setRefreshKey={setRefreshKey}>
                <Layout style={{ minHeight: 'calc(100vh - 64px)' }}>
                    <Content
                        style={{
                            padding: 24,
                            margin: 0,
                            minHeight: 280,
                            background: '#f4f7fa',
                        }}
                    >
                        <Outlet key={refreshKey} />
                    </Content>
                </Layout>
                </MenuSidebar>
            </Layout>
        </Layout>
    );
};

